import React from 'react';
import A_participants from './A_participants';

// Route /online-users. The live participants view (with its own AppShell and
// WebSocket connection) lives in A_participants; this is just the route entry.
const A_Online_users = () => <A_participants />;

export default A_Online_users;
